import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../../../constants/storeLinks';
import type { MobileWebOs } from './detectMobileWebOsFromUserAgent.helper';

/**
 * Picks the public store URL for a detected mobile-web OS. Falls back to the
 * Google Play listing when the OS is unknown (non-mobile / undetectable UA).
 */
export function getMobileStoreUrl(os: MobileWebOs | null): string {
  return os === 'ios' ? APP_STORE_URL : GOOGLE_PLAY_URL;
}
